import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import Button from "react-bootstrap/es/Button";
import Select from "react-select";
import FirmyFormComponent from "./FirmyFormComponent";
import BiletyMiesieczneService from "./BiletyMiesieczneService";
import Link from "react-router-dom/Link";
import BiletyJednorazoweService from "./BiletyJednorazoweService";

export default class BiletyJednorazoweFaktura extends Component {

    constructor(props) {
        super(props);

        this.state = {
            idBi: this.props.idBi,
            firmaDoFaktury: null,
            fakturaVat: false,
            dodajFirme: false,
            imieInvalid: false,
            nazwiskoInvalid: false,
            podanoNip: false,
            loading: true
        };

        this.onChangeFirmaDoFaktury = this.onChangeFirmaDoFaktury.bind(this)
        this.onClickZapiszFirme = this.onClickZapiszFirme.bind(this)
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        BiletyJednorazoweService.getBilet(this.props.idBi)
            .then(function (response) {
                this.setState({nipParagon: response.data.nipParagon, loading: false})
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    onChangeFirmaDoFaktury(e) {
        this.setState({
            firmaDoFaktury: e
        })
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (czyEdycja) {
            BiletyMiesieczneService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury;
                obiekt['nazwa'] = obj.nazwa;
                obiekt['kodPocztowy'] = obj.kodPocztowy;
                obiekt['regon'] = obj.regon;
                obiekt['miejscowosc'] = obj.miejscowosc;
                obiekt['nrLokalu'] = obj.nrLokalu;
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci;
                obiekt['ulica'] = obj.ulica;
                obiekt['wojewodztwo'] = obj.wojewodztwo;
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa;

                this.setState({
                    firmaDoFaktury: obiekt,
                    dodajFirme: false
                })

            }.bind(this))
        } else {
            BiletyMiesieczneService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            dodajFirme: false
                        })
                    }
                }
            }.bind(this))

        }
    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return BiletyMiesieczneService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            });
            return {options: arr}
        }.bind(this))
    }

    renderFirmaOption(option) {
        return (
            <div><span className={'label'} title={'NIP'}>{option.nip}</span> {option.nazwa}</div>)
    }

    generujFakture() {
        console.log(this.state.firmaDoFaktury)
        console.log(this.state.idBi)
    }

    render() {
        return <div>

            <h4 style={{textAlign: 'center', marginBottom: 20}}>
                <b>Faktura za bilet: {this.props.idBi}</b></h4>
            <hr/>

            <div className={'row'}>
                <div className={'col-sm-3'}>
                    <input type={'checkbox'} checked={!this.state.fakturaVat}
                           onClick={() => this.setState({fakturaVat: !this.state.fakturaVat})}/> Faktura imienna
                </div>
                <div className={'col-sm-3'}>
                    <input type={'checkbox'} checked={this.state.fakturaVat}
                           onClick={() => this.setState({fakturaVat: !this.state.fakturaVat})}/> Faktura VAT
                </div>
            </div>
            {this.state.dodajFirme ? null : <hr/>}
            {!this.state.fakturaVat ? <div className={'row'}>
                <div className={'col-lg-12 text-center:'} style={{padding: '15px'}}>
                    <b>Osoba, na którą zostanie wystawiona
                        faktura:</b>
                </div>
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-lg-5">
                            <div style={{
                                color: 'grey', fontWeight: 'bold'
                            }}>Dane podstawowe:
                            </div>
                            <div style={{marginTop: 5}}>
                                <label>Imię:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).imie}
                            </div>
                            <div>
                                <label>Nazwisko:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko}
                            </div>
                            {/*<div>*/}
                            {/*    <label>PESEL:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).pesel}*/}
                            {/*</div>*/}
                            <div>
                                <label>Telefon:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).nrTel}
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div style={{
                                color: 'grey', fontWeight: 'bold'
                            }}>&nbsp;
                            </div>
                            <div style={{marginTop: 5}}>
                                <label>Miejscowość:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).miejscowosc}
                            </div>
                            <div>
                                <label>Kod pocztowy:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).kodPoczt}
                            </div>
                            <div>
                                <label>Ulica:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).ulica}
                            </div>
                            <div>
                                <label>Numer domu:</label> {JSON.parse(sessionStorage.getItem('loggedIn')).nrDomu}
                                {JSON.parse(sessionStorage.getItem('loggedIn')).nrMieszk !== '' ? '/' + JSON.parse(sessionStorage.getItem('loggedIn')).nrMieszk : null}
                            </div>
                        </div>
                        <div className="col-lg-2 text-right">
                            <Link to={'/konto/dane'}><Button
                                titleContent={'Edytuj dane osobowe'}
                                style={{background: '#ffc107', color: '#fff'}}>Edytuj</Button></Link>
                        </div>
                    </div>
                </div>
            </div> : <div className={'row'}>
                {this.state.dodajFirme ? null : <div className={'col-sm-12'}>
                    <b>Wyszukaj firmę:</b>
                    <div style={{marginTop: 10}}>
                        <Select.Async value={this.state.firmaDoFaktury} onChange={this.onChangeFirmaDoFaktury}
                                      valueKey="idFi"
                                      labelKey="informacje" loadOptions={this.getCompanies} clearable={false}
                                      backspaceRemoves={true}
                                      placeholder={'Wyszukaj firmę po NIP lub po nazwie'}
                                      loadingMessage={'Ładowanie...'}
                                      valueRenderer={(option) => this.renderFirmaOption(option)}
                                      optionRenderer={(option) => this.renderFirmaOption(option)}
                                      ignoreAccents={false}
                                      noResultsText={<div>Brak wyników <Button bsStyle={'success'}
                                                                               onClick={() => this.setState({
                                                                                   dodajFirme: true,
                                                                                   firmaDoFaktury: ''
                                                                               })}
                                                                               text={'Dodaj nową firmę'}
                                                                               bsSize={'small'}>Dodaj
                                          firmę</Button>
                                      </div>}
                        />
                    </div>
                </div>}
                {this.state.dodajFirme ? <div className={'col-sm-12'}>
                    <FirmyFormComponent
                        edytowanaFirma={this.state.firmaDoFaktury}
                        handleClickAnuluj={() => {
                            this.setState({dodajFirme: false})
                        }}
                        handleClickZapisz={this.onClickZapiszFirme}
                    />
                </div> : null
                }
            </div>}
            {
                (Boolean(this.state.firmaDoFaktury) && this.state.fakturaVat && !this.state.dodajFirme) ?
                    <div>
                        <hr/>
                        <div className="row">
                            <div className={'col-lg-12 text-center:'} style={{padding: '15px'}}>
                                <b>Firma, na którą zostanie wystawiona
                                    faktura:</b>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div style={{
                                    color: 'grey', fontWeight: 'bold'
                                }}>Dane podstawowe:
                                </div>
                                <div style={{marginTop: 5}}>
                                    <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                </div>
                                <div><label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                </div>
                                {
                                    Boolean(this.state.firmaDoFaktury.regon) ?
                                        <div>
                                            <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                        </div>
                                        :
                                        ''
                                }
                            </div>
                            <div className="col-lg-4">
                                <div style={{
                                    color: 'grey', fontWeight: 'bold'
                                }}>Adres:
                                </div>
                                <div style={{marginTop: 5, lineHeight: '32px'}}>
                                    {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                </div>
                                <div>
                                    {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                </div>
                            </div>
                            <div className="col-lg-4 text-right">
                                <Button
                                    onClick={() => this.setState({dodajFirme: true})}
                                    titleContent={'Edytuj dane firmy'}
                                    style={{background: '#ffc107', color: '#fff'}}>Edytuj</Button>
                                <Button
                                    onClick={() => this.setState({dodajFirme: false, firmaDoFaktury: ''})}
                                    titleContent={'Test'}
                                    style={{background: '#57b13c', color: '#fff', marginLeft: 10}}>Zmień firmę</Button>
                            </div>
                        </div>
                    </div>
                    :
                    ''
            }

            <hr/>
            <div className="row" style={{marginTop: 25}}>

                <div className="col-sm-12 text-right">
                    <Button bsStyle={'success'} onClick={() => {
                        this.generujFakture();
                    }}>Pobierz fakturę</Button>
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyJednorazoweFaktura.js